import { SET_TABLE_FILTERS, UPDATE_SEARCH_TEXT } from "../../constants/actionTypes";

const initialState = {
  filteredData: [],
  searchText: '',
}
const dataTable = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TABLE_FILTERS:
      return {
        ...state,
        filteredData: payload,
      };
    case UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: payload,
      };
    default:
      return state;
  }
};

export default dataTable;
